import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { GITHUB_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const GitHubIcon = (props: IconGlyphProps) => <Icon {...props} glyph={GITHUB_GLYPH} />;
